import React from 'react'
import { Box, Hidden, Typography } from '@material-ui/core'

import { ScreenLoading } from 'layouts/Main/components'
import { Stepper } from './components'

import useAuth from 'hooks/useAuth'
import useClientPortalTheme from 'hooks/useClientPortalTheme'
import useJourneyWhiteLabel from 'hooks/useJourneyWhiteLabel'

import logoDponetWhite from 'images/dponet-logo-white.svg'
import useStyles from './styles'

const JourneyWhiteLabel = ({ children }) => {
  const { clientPortalTheme, isLoading } = useClientPortalTheme()
  const { steps, currentStep } = useJourneyWhiteLabel()

  const auth = useAuth()

  const classes = useStyles()

  return (
    <ScreenLoading loaded={!isLoading && auth.loaded}>
      <Box component="main" className={classes.root}>
        <Box>
          <Box className={classes.leftLogo}>
            <img
              src={clientPortalTheme?.logo || logoDponetWhite}
              alt="Logo DPOnet Branca"
              className={classes.dponetLogo}
            />
            <Hidden smDown>
              <Box px={10} mb={5} textAlign="justify">
                <Typography
                  variant="subtitle1"
                  color="inherit"
                  fontWeight={400}
                >
                  {steps[currentStep]?.description}
                </Typography>
              </Box>
            </Hidden>
            <Stepper />
          </Box>
        </Box>
        <Box className={classes.wrapper}>
          <Box height="100%">{children}</Box>
        </Box>
      </Box>
    </ScreenLoading>
  )
}

export default JourneyWhiteLabel
